/*----- Imports -----*/
import React 		 from 'react'
import styled 	 from 'styled-components'

/*----- Assets -----*/
import searchIcon from '../../assets/icons/search.svg'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'

/*----- Components -----*/
import Spinner 			 from '../../components/commons/Spinner'
import RenderResults from './RenderResults'

/*----- Styles-----*/
const StyledSearchInput = styled.div`
	background: white;
  height: 56px;
	padding: 0 16px;
	width: fit-content;
	display: flex;
	align-items: center;
	border-radius: 10px 10px 0 0;
	box-shadow: 0 8px 16px 8px rgba(58,128,244,0.1);
	position: relative;
	z-index: 1;
	.search-input__icon {
		width: 16px;
	}
	input {
		${ Montserrat(16, 400, 'gray') };
		border: none;
		height: 100%;
		max-width: 300px;
		width: 100%;
		padding: 0 32px 0 16px;
		&:focus {
			outline: none;
		}
	}
	.search-input__spinner {
		transform: scale(0.4);
		position: absolute;
    right: 0;
	}
	.search-results {
		position: absolute;
    top: 64px;
    left: 0;
	}

`

/*----- Component -----*/
const SearchInput = ({ onChange, isLoading, data, handleOnClickProduct, noRender, placeholder='Buscar...' }) => {

	return(
		<StyledSearchInput className="search-input" onChange={onChange}>
			<img src={searchIcon} alt="search icon" className="search-input__icon" />
	  	<input placeholder={placeholder} type="text" id="search" name="search" onChange={onChange}  />
			{
				isLoading? (
					<div className="search-input__spinner">
						<Spinner />
					</div>
				) : null
			}
			{ data && !noRender? <RenderResults data={data} handleOnClickProduct={handleOnClickProduct} /> : null }
  	</StyledSearchInput>
	)
}
export default SearchInput